import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// Client Redux States
import
  {
    GET_CLIENTS,
    ADD_NEW_CLIENT,
    UPDATE_CLIENT,
  } from "./actionType";

import
  {
    clientApiResponseSuccess,
    clientApiResponseError,

    addClientFail,
    addClientSuccess,
    updateClientSuccess,
    updateClientFail,
  } from "./action";

//Include Both Helper File with needed methods
import
  {
    getClients as getClientsApi,
    addNewClient,
    updateClient,
  } from "../../helpers/fakebackend_helper";

function* getClients ()
{
  try
  {
    const response = yield call( getClientsApi );
    console.log( "response: ", response );
    yield put( clientApiResponseSuccess( GET_CLIENTS, response ) );
  } catch ( error )
  {
    yield put( clientApiResponseError( GET_CLIENTS, error ) );
  }
}

function* onUpdateClient ( { payload: client } )
{
  console.log( client );
  try
  {
    const response = yield call( updateClient, client );
    console.log( response );
    yield put( updateClientSuccess( response ) );
  } catch ( error )
  {
    console.log( error );
    yield put( updateClientFail( error ) );
  }
}


function* onAddNewClient ( { payload: client } )
{
  try
  {
    console.log( client );
    const response = yield call( addNewClient, client );
    yield put( addClientSuccess( response ) );
  } catch ( error )
  {
    yield put( addClientFail( error ) );
  }
}

export function* watchGetClients ()
{
  yield takeEvery( GET_CLIENTS, getClients );
}


export function* watchUpdateClient ()
{
  yield takeEvery( UPDATE_CLIENT, onUpdateClient );
}

export function* watchAddNewClient ()
{
  yield takeEvery( ADD_NEW_CLIENT, onAddNewClient );
}

function* clientSaga ()
{
  yield all( [
    fork( watchGetClients ),
    fork( watchUpdateClient ),
    fork( watchAddNewClient ),
  ] );
}

export default clientSaga;
